import "../styles/globals.css"
import type { AppProps } from "next/app";
import { LanguageProvider } from "@/components/context/LanguageContext";
import { Suspense } from "react";
import Loading from "@/components/loading";
import { Manrope } from "next/font/google";
import Head from "next/head";

const manrope = Manrope({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],
  variable: '--font-manrope', // optional
});
export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
    <Head>
      <title>Home</title>
      <meta name="description" content="Generated by create next app" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/ahp-logo.ico" />
    </Head>
    <main className={manrope.className}>
      <LanguageProvider initialLanguage="id">
        {/* <AppShell> */}
          <Suspense fallback={<Loading />}>
            <Component {...pageProps} />
          </Suspense>
        {/* </AppShell> */}
      </LanguageProvider>
    </main>
    </>
  );
}
